import { registerReactComponent } from '@trp-beacon-ui-kit/foundation/react/register';
import { BeaconButton } from '@trp-beacon-ui-kit/foundation/components/beacon-button';
import { BeaconIconButton } from '@trp-beacon-ui-kit/foundation/components/beacon-icon-button';
import { BeaconModal } from '@trp-beacon-ui-kit/foundation/components/beacon-modal';

// Prefix value for beacon components
const projectNamePrefix = 'nasu-mf';

// Beacon Button component
export const MFBeaconButton = registerReactComponent(
  projectNamePrefix,
  BeaconButton
);

// Beacon button component with icon
export const MFBeaconIconButton = registerReactComponent(
  projectNamePrefix,
  BeaconIconButton
);

// Beacon modal component
export const MFBeaconModal = registerReactComponent(
  projectNamePrefix,
  BeaconModal
);
